import WebsocketHeartbeat from './WebSocketHeartbeat.js';
export default class GameServer {
    constructor(url) {
        //todo: use a websocket library - https://github.com/zimv/websocket-heartbeat-js
        this.socket = null;
        this.serverUrlDefault = 'wss://cribbageserver.jimmyinteractive.com';
        this.serverUrl = url || this.serverUrlDefault;
        this.debug = true;
        this.tablePosition = null;
        this.room = null;
        this.spectators = 0;



        this.user = {
            id: Math.floor(Math.random() * 1000),
            name: "user" + Math.floor(Math.random() * 1000),
            avatar: "avatar"
        };

        this.onReceive = function () { };
        this.onSendMessage = function () { };
        this.onConnect = function () { };
        this.onDisconnect = function () { };
        this.onReconnecting = function () { };
        this.onErrorNetwork = function () { };
        this.onLogin = function () { };
        this.onJoin = function () { };
        this.onUserJoin = function () { };
        this.onLeave = function () { };
        this.onMessage = function () { };
        this.onInvite = function () { };
        this.onInvited = function () { };
        this.onStats = function () { };
        this.onUserData = function () { };

        //close the socket whenthe window or page closes
        if (window) {
            window.addEventListener("beforeunload", () => {
                this.close();
            });
        }
    }

    isConncted() {
        if (this.socket && this.socket.readyState === 1) {
            return true;
        }
        return false
    }
    connectAsync(user, serverUrl) {
        if (user) this.user = user;
        if (!user) user = this.user;
        if (serverUrl === "") serverUrl = this.serverUrlDefault; //use default server
        if (serverUrl) this.serverUrl = serverUrl; //use new server
        if (!serverUrl) serverUrl = this.serverUrl; //use last set server

        var promise = new Promise(function (resolve, reject) {
            //clean up old socket and event handler to it or keep one instance of it
            if (this.socket) {
                this.socket.onopen = null;
                this.socket.onclose = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onreconnect = null;
                this.socket.close();
                this.socket = null;
            }
            this.socket = new WebsocketHeartbeat({ url: serverUrl });
            this.socket.onopen = function () {
                this.socket.onerror = this.onError.bind(this);//hook onError for error during connection

                console.log("GameServer: Socket opened");

                //todo: wait for login to return then resolve
                this.login(user);

                resolve();
            }.bind(this);
            this.socket.onerror = function (err) {
                reject(err);
            };
            this.socket.onclose = this.onClosed.bind(this);
            this.socket.onmessage = this.onSocketMessage.bind(this);
            this.socket.onreconnect = this.onReconnect.bind(this);
        }.bind(this));
        return promise;
    }
    close(reason) {
        if (!reason) reason = 1000;
        if (this.socket)
            this.socket.close(reason);
    }
    onSocketMessage(e) {
        let data = e.data;
        var message = this.parseData(data);
        this.serverMessage(message.command, message.value);
    }
    onReconnect(message) {
        console.log('GameServer: reconnecting... ' + message);
        if (this.onReconnecting)
            this.onReconnecting(message);
    }
    onClosed(e) {
        let code = e ? e.code : null;
        let reason = e ? e.reason : null;
        console.log(`GameServer: closed ${reason} ${code}`);
        if (this.onDisconnect)
            this.onDisconnect();
        if (code && code != 1000) {
            if (this.onErrorNetwork) this.onErrorNetwork(e);
        }
    }
    onError(e) {
        console.error('GameServer: Socket Error');
        if (this.onDisconnect)
            this.onDisconnect();
        if (this.onErrorNetwork)
            this.onErrorNetwork(e);
    }



    //server messages
    serverMessage(command, value) {

        if (command === "login") {
            if (this.onLogin)
                this.onLogin(value);
        }
        if (command === "stats") {
            if (this.onStats)
                this.onStats(value);
        }
        if (command === "userData") {
            if (this.onUserData)
                this.onUserData(value);
        }
        if (command === "joined") {
            console.log("joined");
            this.tablePosition = value;

            if (this.onJoin)
                this.onJoin(this.tablePosition);
        }
        if (command === "room") {
            if (value) {
                this.room = value.id;
                this.isRanked = value.isRanked;
                this.spectators = value.spectators;
            }
            if (this.onRoom)
                this.onRoom(value);
        }
        if (command === "joinRoom") {
            if (value) {
                this.room = value.id;
                this.isRanked = value.isRanked;
                this.spectators = value.spectators;
            }
            if (this.onJoinRoom)
                this.onJoinRoom(value);
        }
        if (command === "leave") {
            if (value) {
                this.room = null;
                this.isRanked = null;
                this.spectators = null;
            }
            if (this.onLeave)
                this.onLeave();
        }
        if (command === "message") {
            if (this.onMessage)
                this.onMessage(value);
        }
        if (command === "invite") {
            if (this.onInvite)
                this.onInvite(value);
        }
        if (command === "invited") {
            if (this.onInvited)
                this.onInvited(value);
        }

        //catch all
        if (this.onReceive)
            this.onReceive(command, value);

    }
    //user actions
    action(command, value, player) {
        this.sendMessage("action", {
            command: command,
            value: value,
            player: player
        });
    }
    login(userData) {
        //get last 50 max
        let blockedPlayers = userData.blockedPlayers || [];
        blockedPlayers = blockedPlayers.slice(-50);
        let user = {
            id: userData.id,
            name: userData.name,
            email: userData.email,
            facebookId: userData.facebookId,
            avatar: userData.avatar,
            rating: userData.rating,
            rank: userData.rank,
            blockedPlayers: blockedPlayers,
            board: userData.board,
            background: userData.background,
            deck: userData.deck,
            background: userData.background,
        }
        this.sendMessage("login", user);
    }
    join(room) {
        this.sendMessage("join", room);
    }
    spectate(room) {
        this.sendMessage("spectate", room);
    }
    invite(userId, room) {
        var promise = new Promise(function (resolve, reject) {
            this.sendMessage("invite", { userId: userId, room: room });
            this.onInvited = function (data) {
                resolve(data);
            }.bind(this);
        }.bind(this));
        return promise;
    }
    block(id) {
        this.sendMessage("block", id);
    }
    userData() {
        this.sendMessage("userData");
    }
    stats() {
        this.sendMessage("stats");
    }
    leave() {
        this.sendMessage("leave");
    }
    destroy() {
        //// this.socket.close();
        // this.onDisconnect = function () { };
        // this.onJoin = function () { };
        // this.onLeave = function () { };

    }
    sendMessage(message, value) {
        this.socket.send(`${message}:${JSON.stringify(value)}`);
    }

    //helper
    parseData(data) {
        var command = null;
        var value = null;
        if (typeof data === "string") {
            //split cmd and value
            if (data.indexOf(":") > -1) {
                command = data.split(":")[0];
                value = data.substring(data.indexOf(":") + 1);
                //try to phase json
                try {
                    value = JSON.parse(value);
                } catch (e) { }
            } else {
                command = data;
            }
        }
        var message = { command: command, value: value };
        return message;
    }
    //----------http requests--------------//
    getHttpServer() {
        let baseUrl = this.serverUrl;
        if (baseUrl.includes("ws://"))
            baseUrl = baseUrl.replace("ws://", "http://");
        if (baseUrl.includes("wss://"))
            baseUrl = baseUrl.replace("wss://", "https://");
        return baseUrl
    }
    getUser(userId) {
        var baseUrl = this.getHttpServer();

        var url = `/user/${userId}`;
        url = baseUrl + url;

        return this.makeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    getStats() {
        var baseUrl = this.getHttpServer();

        var url = "/stats";
        url = baseUrl + url;

        return this.makeRequest("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    makeRequest(method, url, data, ContentType) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("cache-control", "private");
            if (ContentType) xhr.setRequestHeader("Content-type", ContentType);
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    // var returnData = JSON.parse(xhr.responseText);
                    resolve(xhr.responseText);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            if (!data)
                xhr.send();
            else
                xhr.send(data);
        });
    };
}




